import { withNamespaces } from "react-i18next";
import { useQuery } from "@tanstack/react-query";
import { Row, Col } from "reactstrap";
import { toast } from "react-toastify";
import DataProtectionTomsService from "src/modules/data-protection/apis/DataProtectionTomsService";
import StatsCards from "./components/StatsCards";
import NeedsAttentionCard from "./components/NeedsAttentionCard";
import RevisionWidget from "./components/RevisionWidget";
import CompletionWidget from "./components/CompletionWidget";
import RecentActivityWidget from "./components/RecentActivityWidget";
import LegalEntitiesWithoutTomWidget from "./components/LegalEntitiesWithoutTomWidget";

const DataProtectionTomsDashboard = ({ t }) => {
  const {
    data: dashboardData,
    isFetching,
  } = useQuery({
    queryKey: ["tom-dashboard"],
    queryFn: async () => {
      const service = DataProtectionTomsService.getInstance();
      return await service.dashboard();
    },
    cacheTime: 0,
    refetchOnWindowFocus: false,
    onError: (error) => {
      if (process.env.NODE_ENV === "development") console.error(error);

      toast(t("An error occurred while fetching dashboard data."), {
        type: "error",
      });
    },
  });

  return (
    <div>
      <Row className="mb-4">
        <Col>
          <Row>
            <Col sm="12">
              <StatsCards
                stats={dashboardData?.stats}
                t={t}
                isFetching={isFetching}
              />
            </Col>
          </Row>
        </Col>
      </Row>
      <Row className="mb-4">
        <Col lg="6" md="6" sm="12" className="mb-4">
          <NeedsAttentionCard
            data={dashboardData?.needs_attention}
            t={t}
            isFetching={isFetching}
          />
        </Col>
        <Col lg="6" sm="12" className="mb-4">
          <CompletionWidget
            data={dashboardData?.completion}
            t={t}
            isFetching={isFetching}
          />
        </Col>
      </Row>
      <Row className="mb-4">
        <Col md="6" sm="12" className="mb-4">
          <RevisionWidget
            title={t("Revision Overdue")}
            tooltipText={t("These TOMs have overdue revision dates.")}
            data={dashboardData?.revision_overdue}
            t={t}
            isFetching={isFetching}
          />
        </Col>
        <Col md="6" sm="12" className="mb-4">
          <RevisionWidget
            title={t("Revision Due Soon")}
            tooltipText={t("These TOMs require revision soon.")}
            data={dashboardData?.revision_due_soon}
            t={t}
            isFetching={isFetching}
          />
        </Col>
      </Row>
      <Row className="mb-4">
        <Col lg="6" md="6" sm="12" className="mb-4">
          <LegalEntitiesWithoutTomWidget
            data={dashboardData?.legal_entities_without_tom}
            t={t}
            isFetching={isFetching}
          />
        </Col>

        <Col lg="6" md="6" sm="12" className="mb-4">
          <RevisionWidget
            title={t("Unassigned")}
            tooltipText={t("These TOMs do not have an assigned analyst.")}
            data={dashboardData?.unassigned}
            t={t}
            isFetching={isFetching}
          />
        </Col>
      </Row>
      <Row className="mb-4">
        <Col sm="12" className="mb-4">
          <RecentActivityWidget
            data={dashboardData?.recent_activity}
            t={t}
            isFetching={isFetching}
          />
        </Col>
      </Row>
    </div>
  );
};

export default withNamespaces()(DataProtectionTomsDashboard);
